import React from "react";
import { Box, Tooltip } from "@mui/material";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";

import ISODateTime from "./ISODateTime";

// Used for pretty printing relative date strings
dayjs.extend(relativeTime);

interface ISORelativeDateTimeProps {
  isoString: string;
  hideTooltip?: boolean;
}

export function relativeTimeString(date: Date): string {
  return dayjs(date).fromNow();
}

export default function ISORelativeDateTime(props: ISORelativeDateTimeProps): React.JSX.Element {
  const date = new Date(props.isoString);
  const relativeTime = relativeTimeString(date);
  return (
    <Tooltip followCursor title={props.hideTooltip ? "" : <ISODateTime isoString={props.isoString} hideTooltip={true} />}>
      <Box>{relativeTime}</Box>
    </Tooltip>
  )
}